









































import Vue from 'vue';
import Component from 'vue-class-component';
import {Action, Getter} from 'vuex-class';

import { tabs } from '@/modules/neopvc/models';
import { GetterTypes, ActionTypes } from '../../store/types';

@Component({})
export default class extends Vue {
  public tabs = tabs;
  public actionTabs = {
    [tabs.form]: () => {
      this.updateNewProject(true);
      this.updateCurrentTab(this.tabs.form);
      this.$router.push('/neopvc/project/form');
    },
    [tabs.list]: () => {
      this.updateNewProject(false);
      this.updateCurrentTab(this.tabs.list);
      this.$router.push('/neopvc/project');
    },
    [tabs.process]: () => {
      this.updateNewProject(false);
      this.updateCurrentTab(this.tabs.process);
      this.$router.push('/neopvc/project/process');
    },
    [tabs.audit]: () => {
      this.updateNewProject(false);
      this.updateCurrentTab(this.tabs.audit);
      this.$router.push('/neopvc/project/audit');
    },
  };

  @Getter(GetterTypes.GET_CURRENT_TAB)
  public currentTab: string;

  @Getter(GetterTypes.GET_NEW_PROJECT)
  public newProject: boolean;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public updateCurrentTab: (tab: string) => void;

  @Action(ActionTypes.UPDATE_NEW_PROJECT)
  public updateNewProject: (newProject: boolean) => void;

  public onNewProject() {
    this.actionTabs[this.tabs.form]();
  }

  public onChangeTab(newValue: string) {
    this.updateCurrentTab(newValue);
    this.actionTabs[newValue]();
  }
}
